import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { FaCity } from "react-icons/fa";

const CompanyInformation = ({ data }) => {
  const [company, setCompany] = useState(data);
  const [isEditing] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCompany({ ...company, [name]: value });
  };

  return (
    <div className={styles.informacionPersonal} id="personal">
      <h2 className={styles.sectionTitle}>Información de la Empresa</h2>

      {!company ? (
        <NotReportViewData title="Información de la Empresa" Icon={FaCity} />
      ) : (
        <>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Razón social:
              <input
                className={styles.inputField}
                type="text"
                name="nombre"
                value={company.companyName || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Cuit:
              <input
                className={styles.inputField}
                type="text"
                name="cuil"
                value={company.cuit || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Años:
              <input
                className={styles.inputField}
                type="text"
                name="age"
                value={company.age || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>

          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Teléfono:
              <input
                className={styles.inputField}
                type="tel"
                name="telefono"
                value={company.phone || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Correo electrónico:
              <input
                className={styles.inputField}
                type="email"
                name="correo_electronico"
                value={company.email || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Codigo de actividad laboral:
              <input
                className={styles.inputField}
                type="text"
                name="codeOfWorkActivity"
                value={company.codeOfWorkActivity || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>

          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Calle:
              <input
                className={styles.inputField}
                type="text"
                name="street"
                value={company.street || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Numero:
              <input
                className={styles.inputField}
                type="text"
                name="numberStreet"
                value={company.numberStreet || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Codigo postal:
              <input
                className={styles.inputField}
                type="text"
                name="postalCode"
                value={company.postalCode || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>

          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Localidad:
              <input
                className={styles.inputField}
                type="text"
                name="location"
                value={company.location || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Provincia:
              <input
                className={styles.inputField}
                type="text"
                name="province"
                value={company.province || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Pais de residencia:
              <input
                className={styles.inputField}
                type="text"
                name="nacionality"
                value={company.nacionality || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Piso:
              <input
                className={styles.inputField}
                type="text"
                name="floor"
                value={company.floor || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Departamento:
              <input
                className={styles.inputField}
                type="text"
                name="apartment"
                value={company.apartment || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.inputLabel}>
              Actividad que desarrolla:
              <textarea
                className={styles.inputField}
                type="text"
                name="ActivityBeingCarriedOut"
                value={company.ActivityBeingCarriedOut || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
        </>
      )}
    </div>
  );
};

export default CompanyInformation;
